// ################### LANGIN ACTION ################## :
export const SEND_POST_AS_DRAFT = "SEND_POST_AS_DRAFT";
export const INIT_SEND_POST_AS_DRAFT = "INIT_SEND_POST_AS_DRAFT";
export const SUCCESS_SEND_POST_AS_DRAFT = "SUCCESS_SEND_POST_AS_DRAFT";
export const FAIL_SEND_POST_AS_DRAFT = "FAIL_SEND_POST_AS_DRAFT";

// ################# PREVIEW ACTION ################ :
export const GET_PREVIEW_POST = "GET_PREVIEW_POST";
export const INIT_GET_PREVIEW_POST = "INIT_GET_PREVIEW_POST";
export const SUCCESS_GET_PREVIEW_POST = "SUCCESS_GET_PREVIEW_POST";
export const FAIL_GET_PREVIEW_POST = "FAIL_GET_PREVIEW_POST";
// submit post:
export const SEND_POST_SUBMIT = "SEND_POST_SUBMIT";
export const INIT_SEND_POST_SUBMIT = "INIT_SEND_POST_SUBMIT";
export const SUCCESS_SEND_POST_SUBMIT = "SUCCESS_SEND_POST_SUBMIT";
export const FAIL_SEND_POST_SUBMIT = "FAIL_SEND_POST_SUBMIT";

//############## AUTENTICATIONS ACTIONS ################## :
export const START_AUTHENTICATING = "START_AUTHENTICATING";
export const INIT_AUTHENTICATING = "INIT_AUTHENTICATING";
export const SUCCESS_AUTHENTICATING = "SUCCESS_AUTHENTICATING";
export const CHANGED_USER_AUTHENTICATING = "CHANGED_USER_AUTHENTICATING";
export const FAIL_AUTHENTICATING = "FAIL_AUTHENTICATING";
export const VERIFI_AFTER_SIGN_UP = "VERIFI_AFTER_SIGN_UP";
export const CLEAR_ERROR = "CLEAR_ERROR";
export const LOGOUT_AUTHENTICATION = "LOGOUT_AUTHENTICATION";
export const SUCCESS_LOGOUT_AUTHENTICATION = "SUCCESS_LOGOUT_AUTHENTICATION";
export const GOOGLE_AUTHENTICATION = "GOOGLE_AUTHENTICATION";
// Current User Data  :
export const GET_CURRENT_LOGED_USER_DATA = "GET_CURRENT_LOGED_USER_DATA";
export const SUCCESS_GET_CURRENT_LOGED_USER_DATA =
  "SUCCESS_GET_CURRENT_LOGED_USER_DATA";
export const FAIL_GET_CURRENT_LOGED_USER_DATA =
  "FAIL_GET_CURRENT_LOGED_USER_DATA";

// ######################## EDIT POST ######################## :
export const GET_EDIT_POST = "GET_EDIT_POST";
export const INIT_GET_EDIT_POST = "INIT_GET_EDIT_POST";
export const SUCCESS_GET_EDIT_POST = "SUCCESS_GET_EDIT_POST";
export const FAIL_GET_EDIT_POST = "FAIL_GET_EDIT_POST";
// Save edited Post:
export const PUT_EDIT_POST = "PUT_EDIT_POST";
export const INIT_PUT_EDIT_POST = "INIT_PUT_EDIT_POST";
export const SUCCESS_PUT_EDIT_POST = "SUCCESS_PUT_EDIT_POST";
export const FAIL_PUT_EDIT_POST = "FAIL_PUT_EDIT_POST";

// ######################## ACTIVITES  ######################## :
//GET Post :
export const GET_ACTIVTY_POSTS = "GET_ACTIVTY_POSTS";
export const INIT_GET_ACTIVTY_POSTS = "INIT_GET_ACTIVTY_POSTS";
export const SUCCESS_GET_ACTIVTY_POSTS = "SUCCESS_GET_ACTIVTY_POSTS";
export const FAIL_GET_ACTIVTY_POSTS = "FAIL_GET_ACTIVTY_POSTS";
//Purchase From Pcari:
export const PURCHASE_FROM_PCARI = "PURCHASE_FROM_PCARI";
export const INIT_PURCHASE_FROM_PCARI = "INIT_PURCHASE_FROM_PCARI";
export const SUCCESS_PURCHASE_FROM_PCARI = "SUCCESS_PURCHASE_FROM_PCARI";
export const FAIL_PURCHASE_FROM_PCARI = "FAIL_PURCHASE_FROM_PCARI";
//Get Moderator CommentsL:
export const GET_MODERATOR_COMMENTS = "GET_MODERATOR_COMMENTS";
export const INIT_GET_MODERATOR_COMMENTS = "INIT_GET_MODERATOR_COMMENTS";
export const SUCCESS_GET_MODERATOR_COMMENTS = "SUCCESS_GET_MODERATOR_COMMENTS";
export const FAIL_GET_MODERATOR_COMMENTS = "FAIL_GET_MODERATOR_COMMENTS";
//Get Post CommentsL:
export const GET_POST_COMMENTS = "GET_POST_COMMENTS";
export const SUCCESS_GET_POST_COMMENTS = "SUCCESS_GET_POST_COMMENTS";
export const FAIL_GET_POST_COMMENTS = "FAIL_GET_POST_COMMENTS";
// Get Payment History:
export const GET_PAYMENT_HISTORY = "GET_PAYMENT_HISTORY";
export const INIT_GET_PAYMENT_HISTORY = "INIT_GET_PAYMENT_HISTORY";
export const SUCCESS_GET_PAYMENT_HISTORY = "SUCCESS_GET_PAYMENT_HISTORY";
export const FAIL_GET_PAYMENT_HISTORY = "FAIL_GET_PAYMENT_HISTORY";

// Get Invoices :
export const GET_INVOICES = "GET_INVOICES";
export const INIT_GET_INVOICES = "INIT_GET_INVOICES";
export const SUCCESS_GET_INVOICES = "SUCCESS_GET_INVOICES";
export const FAIL_GET_INVOICES = "FAIL_GET_INVOICES";

// ################################### Messages  ########################:

export const Get_Messages = "Get_Messages";
export const INIT_Get_Messages = "INIT_Get_Messages";
export const SUCCESS_Get_Messages = "SUCCESS_Get_Messages";
export const FAIL_Get_Messages = "FAIL_Get_Messages";
// get all Users :
export const GET_ALL_USERS = "GET_ALL_USERS";
export const INIT_ALL_USERS = "INIT_ALL_USERS";
export const SUCCESS_ALL_USERS = "SUCCESS_ALL_USERS";
export const FAIL_ALL_USERS = "FAIL_ALL_USERS";

// ################################## Chat ##################################:

// export const GET_CHAT = 'GET_CHAT';
// export const INIT_GET_CHAT = 'INIT_GET_CHAT';
// export const SUCCESS_GET_CHAT = 'SUCCESS_GET_CHAT';
// export const FAIL_GET_CHAT = 'FAIL_GET_CHAT';
// //clean Chat:
// export const CLEAN_CHAT = 'CLEAN_CHAT';
// // Create message (send message):
// export const CREATE_MESSAGE = 'CREATE_MESSAGE';
// export const INIT_CREATE_MESSAGE = 'INIT_CREATE_MESSAGE';
// export const SUCCESS_CREATE_MESSAGE = 'SUCCESS_CREATE_MESSAGE';
// export const FAIL_CREATE_MESSAGE = 'FAIL_CREATE_MESSAGE';
// // Set as read :
// export const SET_AS_READ = 'SET_AS_READ';
//############ Chat ################ :
export const INIT_GET_CHAT = "INIT_GET_CHAT";
export const INIT_UPDATE_CHAT = "INIT_UPDATE_CHAT";
export const SUCCESS_GET_CHAT = "SUCCESS_GET_CHAT";
export const FAIL_GET_CHAT = "FAIL_GET_CHAT";
// send message
export const INIT_POST_MESSAGE = "INIT_POST_MESSAGE";
export const SUCCESS_POST_MESSAGE = "SUCCESS_POST_MESSAGE";
export const FAIL_POST_MESSAGE = "FAIL_POST_MESSAGE";
export const HOLD_PULLING = "HOLD_PULLING";

// ####################### BECOME A FEATURE DEALER #######################:
export const BECOME_FEATURE_DEALER = "BECOME_FEATURE_DEALER";
export const INIT_BECOME_FEATURE_DEALER = "INIT_BECOME_FEATURE_DEALER";
export const SUCCESS_BECOME_FEATURE_DEALER = "SUCCESS_BECOME_FEATURE_DEALER";
export const FAIL_BECOME_FEATURE_DEALER = "FAIL_BECOME_FEATURE_DEALER";

// ###################### TopUP ################:
export const TopUP_Token = "TopUP_Token";
export const INIT_TopUP_Token = "INIT_TopUP_Token";
export const SUCCESS_TopUP_Token = "SUCCESS_TopUP_Token";
export const FAIL_TopUP_Token = "FAIL_TopUP_Token";

// ##########################  PROFILE  ###################:
export const GET_USER_PROFILE = "GET_USER_PROFILE";
export const INIT_GET_USER_PROFILE = "INIT_GET_USER_PROFILE";
export const SUCCESS_GET_USER_PROFILE = "SUCCESS_GET_USER_PROFILE";
export const FAIL_GET_USER_PROFILE = "FAIL_GET_USER_PROFILE";
//  EDITE USER PROFILE :
export const Edit_USER_PROFILE = "Edit_USER_PROFILE";
export const INIT_Edit_USER_PROFILE = "INIT_Edit_USER_PROFILE";
export const SUCCESS_Edit_USER_PROFILE = "SUCCESS_Edit_USER_PROFILE";
export const FAIL_Edit_USER_PROFILE = "FAIL_Edit_USER_PROFILE";
//Get user profile address:
export const INIT_GET_USER_PROFILE_ADDRESS = "INIT_GET_USER_PROFILE_ADDRESS";
export const SUCCESS_GET_USER_PROFILE_ADDRESS =
  "SUCCESS_GET_USER_PROFILE_ADDRESS";
export const FAIL_GET_USER_PROFILE_ADDRESS = "FAIL_GET_USER_PROFILE_ADDRESS";

//################################
// Add Service:

export const SEND_SERVICE_AS_DRAFT = "SEND_SERVICE_AS_DRAFT";
export const INIT_SEND_SERVICE_AS_DRAFT = "INIT_SEND_SERVICE_AS_DRAFT";
export const SUCCESS_SEND_SERVICE_AS_DRAFT = "SUCCESS_SEND_SERVICE_AS_DRAFT";
export const FAIL_SEND_SERVICE_AS_DRAFT = "FAIL_SEND_SERVICE_AS_DRAFT";

// RequiredForm :
export const PUT_REQUIRED_INFO = "PUT_REQUIRED_INFO";
export const INIT_PUT_REQUIRED_INFO = "INIT_PUT_REQUIRED_INFO";
export const SUCCESS_PUT_REQUIRED_INFO = "SUCCESS_PUT_REQUIRED_INFO";
export const FAIL_PUT_REQUIRED_INFO = "FAIL_PUT_REQUIRED_INFO";
